// Dernier tableau de bord personnalisé consulté (slug), par utilisateur : le menu Overview y ramène
const PREFIX = 'overview/lastDashboard/'

const storageKey = () => {
  try {
    const user = localStorage.user && localStorage.user != 'undefined' ? JSON.parse(localStorage.user) : null
    return `${PREFIX}${(user && user.id) || 'anonymous'}`
  } catch (e) {
    return `${PREFIX}anonymous`
  }
}

export function getLastDashboard() {
  try {
    return localStorage.getItem(storageKey()) || null
  } catch (e) {
    return null
  }
}

export function setLastDashboard(slug) {
  try {
    if (slug) localStorage.setItem(storageKey(), slug)
    else localStorage.removeItem(storageKey())
  } catch (e) { /* indisponible */ }
}
